import {
  alphabeticalCompare,
  CustomFieldDataType,
  CustomFieldClassType,
} from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CIMSTags } from 'components/CIMSTags'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'

export function useColumns() {
  const columns: CIMSColumn<ProjectCustomField>[] = [
    useNameColumn({
      help: HelpMessage.Administration.CustomFields.Name,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Custom Field'),
    {
      title: 'Data Type',
      help: HelpMessage.Administration.CustomFields.DataType,
      render: ({ dataTypeId }) =>
        CustomFieldDataType.fromIdOrFail(dataTypeId).name,
      sort: {
        with: 'callback',
        onCompare: (a, b) => {
          const A = CustomFieldDataType.fromIdOrFail(a.dataTypeId)
          const B = CustomFieldDataType.fromIdOrFail(b.dataTypeId)
          return alphabeticalCompare(A, B, 'name')
        },
      },
      width: 170,
      filter: {
        with: 'items',
        items: CustomFieldDataType.values.map(({ id, name, description }) => ({
          text: name,
          tooltip: description,
          value: id,
        })),
        key: 'dataTypeId',
      },
    },
    {
      title: 'Associated Record Types',
      width: 230,
      help: HelpMessage.Administration.CustomFields.ClassTypes({
        header: true,
      }),
      render: ({ customFieldToClassTypes }) => (
        <CIMSTags
          tags={customFieldToClassTypes.map(({ classTypeId }) => ({
            text: CustomFieldClassType.fromIdOrFail(classTypeId).type,
          }))}
        />
      ),
      filter: {
        with: 'callback',
        items: CustomFieldClassType.values.map(({ id, type }) => ({
          text: type,
          value: id,
        })),
        onFilter: (value, { customFieldToClassTypes }) =>
          customFieldToClassTypes.some(
            ({ classTypeId }) => classTypeId === value
          ),
      },
    },
  ]

  return columns
}
